/**
 * Function that returns medium date format approved by Wix Localization team.
 * @param locale - language/country short value that is passed to Intl.DateTimeFormat
 * @param date - JavaScript Date objects represent a single moment in time in a platform-independent format.
 */
export const getMediumDate = (locale, date) => {
    return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(date);
};
//# sourceMappingURL=getMediumDate.js.map